import { Component } from '@angular/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { NearbyEvent } from '../../../providers/event/event';

/**
 * Generated class for the NearbyModifyStartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-nearby-modify-start',
  templateUrl: 'nearby-modify-start.html',
})
export class NearbyModifyStartPage {

  active: NearbyEvent;
  resolve: any;
  resolveValue: boolean = false;
  isoDate: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, private app: App) {
    this.active = navParams.data.active;
    this.isoDate = new Date(this.active.date).toISOString();
    this.resolve = this.navParams.get('resolve');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NearbyModifyStartPage');
  }

  save() {
    this.active.date = new Date(this.isoDate).getTime();
    this.app.getRootNav().pop();
  }

  now() {
    this.isoDate = new Date().toISOString();
    this.active.date = new Date(this.isoDate).getTime();
    this.resolveValue = true;
    this.app.getRootNav().pop();
  }

  ionViewWillLeave() {
    if (this.resolve) {
      this.resolve(this.resolveValue);
    }
  }
}



// WEBPACK FOOTER //
// /src/pages/nearby/nearby-modify-start/nearby-modify-start.ts